import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { stepList } from '../slice';
const barCss = "brf4zj5";
const Bar = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(barCss, props.className)} />;
});
const progressWrapperIsTabletDownCss = "p1cvpsjb";
const progressWrapperUseNarrowCss = "p1kzw4ao";
const progressWrapperCss = "p1vbnfsb";
const ProgressWrapper = forwardRef((props, ref) => {
  const {
    useNarrow,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletDown = useDeviceType('isTabletDown');
  return <Component ref={ref} {...restProps} className={classNames(progressWrapperCss, {
    [progressWrapperIsTabletDownCss]: isTabletDown,
    [progressWrapperUseNarrowCss]: useNarrow
  }, props.className)} />;
});
const getProgress = currentTab => (currentTab + 1) / stepList.length * 100;
export const ProgressBar = ({
  currentTab,
  className,
  useNarrow
}) => <ProgressWrapper data-testid="progress-bar" aria-label={I18n.t('publisher.labels.progress_bar')} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={getProgress(currentTab)} className={className} useNarrow={useNarrow}>
    {Array.from(Array(currentTab + 1)).map((_, index) => <Bar key={stepList[index]} data-testid={`progress-bar-${stepList[index]}`} />)}
  </ProgressWrapper>;
ProgressBar.propTypes = {
  currentTab: PropTypes.number.isRequired,
  useNarrow: PropTypes.bool,
  className: PropTypes.string
};

require("./progress_bar.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./progress_bar.js");